var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import { MenubarProgressBar } from './Progressbar/MenubarProgressBar';
import { MenubarProgressGrade } from './Grade/MenubarProgressGrade';
import { runtime } from '../../../classes/runtime/Runtime';
let MenubarProgressButton = class MenubarProgressButton extends React.PureComponent {
    get background() {
        if (this.props.app.menubarProgress.isProgressMenuOpen) {
            return 'linear-gradient(to bottom, #080808 0%, #0f0f0f 100%)';
        }
        return undefined;
    }
    get boxShadow() {
        if (this.props.app.menubarProgress.isProgressMenuOpen) {
            return 'inset 0 3px 9px rgba(0, 0, 0, 0.25)';
        }
        return undefined;
    }
    get color() {
        if (this.props.app.menubarProgress.isButtonHovering || this.props.app.menubarProgress.isProgressMenuOpen) {
            return '#fff';
        }
        return '#9d9d9d';
    }
    render() {
        const { app } = this.props;
        return (React.createElement("div", { style: {
                color: this.color,
                background: this.background,
                boxShadow: this.boxShadow,
                flex: '0 1 auto',
                display: 'flex',
                paddingLeft: 15,
                cursor: 'pointer',
                paddingRight: 10,
                height: 45,
            }, onMouseEnter: action(() => (app.menubarProgress.isButtonHovering = true)), onMouseLeave: action(() => (app.menubarProgress.isButtonHovering = false)), onClick: action(() => {
                const x = runtime.streamedPackages.Lazy;
                app.menubarProgress.isProgressMenuOpen = !app.menubarProgress.isProgressMenuOpen;
            }) },
            React.createElement("div", { style: { flex: '1 1 auto', display: 'flex', flexDirection: 'column' } },
                React.createElement(MenubarProgressBar, { app: app }),
                React.createElement("div", { style: { clear: 'both' } }),
                React.createElement(MenubarProgressGrade, { app: app })),
            React.createElement("div", { style: { flex: '0 1 auto', display: 'flex', alignItems: 'center', paddingLeft: 8 } },
                React.createElement("i", { className: "fas fa-caret-down", style: { flex: '0 1 auto' } }))));
    }
};
MenubarProgressButton = __decorate([
    observer
], MenubarProgressButton);
export { MenubarProgressButton };
